import React, { Component } from 'react';
import { Formik, Form, Field, FieldArray } from 'formik';
import { Button, Grid, Divider, Message } from 'semantic-ui-react';
import { Link,withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import FormsInputsText from '../../../forms/inputs/text/forms_inputs_text';
import FormsInputDropdown from '../../../forms/inputs/dropdown';
import FormsInputsNumber from '../../../forms/inputs/number/forms_inputs_number';
import CommonUtility from "../../../../utils/CommonUtility";
import { USER_TYPE, USER_ROLES } from "../../../../constants";
import {submitSystemAdminCreateClient,getSystemAdminCompanies } from '../../../../actions';
import ListMSBillingCompanySelection from '../../client/list_ms_billing_company_selection';  

import { DndContext, DragOverlay, closestCorners, KeyboardSensor, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { arrayMove, horizontalListSortingStrategy,  sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import Container from "../../../widgets/sortable/container";
import { Item } from "../../../widgets/sortable/sortable_item";

const yesNoOneTwoOptions = [
    { text: 'Yes', value: 1 },
    { text: 'No', value: 0 }
];
const yesNoOneTwoBooleanOptions = [
    { text: 'Yes', value: true },
    { text: 'No', value: false }
];
const defaultElogType = [
    { text: 'Non-Fixed', value: 'NonFixed' },
    { text: 'Fixed', value: 'Fixed' }
];

const filterOptions = [
    { key: 'companyName', text: 'Company Name', value: 'companyName' }, 
    { key: 'groupCode', text: 'Group Code', value: 'groupCode' },
    { key: 'policyNo', text: 'Policy No', value: 'policyNo' },
]

const otpOptions = [
    { text: 'EMAIL', value: 'EMAIL' },
    { text: 'SMS', value: 'SMS' }
]

class SysadminFormsClientUpdate extends Component {
    state = {
        error: false,
        errorMessage: null,
        success: false, 
        isCloned: false,
        size:'',
        open:false,
        loading:false,

        openModalSelectCompany: false,
        currentPage: 1,
        perPage: 10,
        totalPage: 1,
        totalData: 1,
        filter: 'companyName',
        query: '',
        clients:[],
        companyName:null,
        groupCode:null,
        policyNo:null,
        isSearch:false,
        items: {
            root: [],
            container1: []
        },
        teleconsultConfig: {
            root: [],
            container1: []
        },
        activeId: null,
    }

    componentDidMount(){
        window.scrollTo(0, 0);
        this.getClients()
        this.setIdentifier();
        this.setTeleconsultConfig();
    }

    setTeleconsultConfig(){
        const defaultConfigs = ["Post Health Screening", "General Practitioner", "Dietician", "Mental Health", "ART Specialist"]
        let teleconsultConfigs = this.props.client && this.props.client.featuresConfig && this.props.client.featuresConfig.teleconsult_features_config && this.props.client.featuresConfig.teleconsult_features_config.length ? this.props.client.featuresConfig.teleconsult_features_config : []
        let inactiveConfigs = [];
        for(let item of defaultConfigs){
            if(!teleconsultConfigs.includes(item)){
                inactiveConfigs.push(item)
            }
        }

        this.setState({
            teleconsultConfig: {
                root: teleconsultConfigs,
                container1: inactiveConfigs
            }
        })
    }

    setIdentifier(){
        const idItems = ["name", "birthdate", "staffid"]
        let rootItems = this.props.client.enrolmentConfig && this.props.client.enrolmentConfig.secondary_identifier && this.props.client.enrolmentConfig.secondary_identifier.length ? this.props.client.enrolmentConfig.secondary_identifier : []
        let inactiveItems = [];
        for(let item of idItems){
            if(!rootItems.includes(item)){
                inactiveItems.push(item)
            }
        }

        this.setState({
            items: {
                root: rootItems,
                container1: inactiveItems
            }
        })
    }

    renderSubmissionResult() {
        if (this.state.success === true) {
            return (
                <Message positive>
                    {this.state.isCloned?
                    <Message.Header>Client Cloned Successfully!</Message.Header>:
                    <Message.Header>Client Created Successfully!</Message.Header>}
                    {!this.state.isCloned?<p>
                        <Link to="/systemadmin">
                            Click here to view the client now!
                        </Link>
                    </p>:null} 
                </Message>
            );
        }
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there was an issue</Message.Header>
                    <p>
                        { this.state.errorMessage }
                    </p>
                </Message>
            );
        }
    }

    handleCloneClient=(company)=>{ 
        const { client } = this.props
        client.name = company.companyName
        client.groupCode = company.groupCode
        client.policyNo = company.policyNo 
        client.companyMS_company_id = company._id

        this.setState({error: false, errorMessage: null, success: false,loading:true}); 
        this.props.cloneClient(
            {accessToken: this.props.user.accessToken, data: client},
            (result, error) => {   
                if (result) {  
                    this.setState({error: false, errorMessage: null, success: true, isCloned:true, open:false, loading:false}); 
                    this.props.history.push({
                        pathname: `/systemadmin/client/${result.client._id}/update`, 
                        state:{client:result.client}
                    })
                    window.scrollTo(0, 0);
                }
                if (error) { 
                    this.setState({error: true, errorMessage: error.errorMessage,open:false,loading:false});
                }
            }
        )                    

    }

    // ----- start ------
    getClients = () => { 
        this.setState({loading: true})
        const { accessToken } = this.props.user;  
        let params = {}

        if (this.state.query !== '') {
            params[this.state.filter] = this.state.query
        } 
        getSystemAdminCompanies({
            accessToken,
            searchPage: this.state.currentPage,
            searchMax: this.state.perPage,
            params
        }, (result, error) => {  
            if(result && result.data) { 
                if(result.data.pagination) {
                    this.setState({
                        totalPage: result.data.pagination.totalPage,
                        totalData: result.data.pagination.totalData,
                    })
                }
                if(result.data.companies) { 
                    this.setState({
                        clients: result.data.companies,
                        loading: false
                    })
                }
            }
        });
    }
    showCompanyDialog(isShow) {
        if (isShow) {
            this.setState({
                ...this.state,
                openModalSelectCompany: true, 
            })
        } else {
            this.setState({
                ...this.state,
                openModalSelectCompany: false,
            })
        }
    }

    onSelectCompany(client){  
        this.showCompanyDialog(false);
        this.handleCloneClient(client)
    }
    goToPreviousPage = () => {
        if (this.state.currentPage > 1) {
            this.setState({ currentPage: this.state.currentPage - 1 }, () => {
                this.getClients();
            });
        };
    }

    goToNextPage = () => {
        if (this.state.clients.length >= this.state.perPage) {
            this.setState({ currentPage: this.state.currentPage + 1 }, () => {
                this.getClients();
            });
        };
    }

    setPage = (num) => {
        this.setState({ currentPage: num }, () => {
            this.getClients();
        });
    }

    setPerPage = (num) => {
        this.setState({ perPage: num, currentPage: 1 }, () => {
            this.getClients();
        });
    }

    submitFilter = () => {
        if (this.state.query !== '') {
            this.setState({...this.state, currentPage: 1, isSearch:true}, () => {
                this.getClients();
            });
        }
    }

    clearFilter = () => {
        this.setState({ query: '',isSearch:false }, () => {
            this.getClients();
        });
    }

    checkClearFilter = (e) => {
        if(e.target.value == ""){
            this.setState({ query: '' }, () => {
            // this.getClients();
        });
        }
        this.setState({ query: e.target.value })
    }
 
    onFilterDropdownChange = (e,{name, value}) => {    
        if(e.target.value == ""){
            this.setState({ filter: '' })
        } else {
            this.setState({ filter: value });
        }
    }

    findContainer = (id) => {
        let type = 'identifier';

        if(id && ["Post Health Screening", "General Practitioner", "Dietician", "Mental Health", "ART Specialist"].includes(id)){
            type = 'teleconsult';
        }

        let items = this.state.items;
        
        if(type == 'teleconsult'){
            items = this.state.teleconsultConfig
        }
        if (id in items) {
            return id;
        }

        return Object.keys(items).find((key) => items[key].includes(id));
    }
    
    handleDragStart = (event) => {
        const { active } = event;
        const { id } = active;
 
        this.setState({
            activeId: id
        });
    }
    
    handleDragOver = (event) => {
        let type = 'identifier';

        const { active, over, draggingRect } = event;
        const { id } = active;
        const { id: overId } = over;

        if(id && ["Post Health Screening", "General Practitioner", "Dietician", "Mental Health", "ART Specialist"].includes(id)){
            type = 'teleconsult';
        }
        // Find the containers
        const activeContainer = this.findContainer(id);
        const overContainer = this.findContainer(overId);

        if (!activeContainer || !overContainer || activeContainer === overContainer) {
            return;
        }

        let prev = this.state.items;
        if(type == 'teleconsult'){
            prev = this.state.teleconsultConfig
        }
        
        const activeItems = prev[activeContainer];
        const overItems = prev[overContainer];

        // Find the indexes for the items
        const activeIndex = activeItems.indexOf(id);
        const overIndex = overItems.indexOf(overId);

        let newIndex;
        if (overId in prev) {
            // We're at the root droppable of a container
            newIndex = overItems.length + 1;
        } else {
            const isBelowLastItem = over && overIndex === overItems.length - 1 && draggingRect && draggingRect.offsetTop > over.rect.offsetTop + over.rect.height;
            const modifier = isBelowLastItem ? 1 : 0;

            newIndex = overIndex >= 0 ? overIndex + modifier : overItems.length + 1;
        }

        if(type == 'teleconsult'){
            this.setState({
                teleconsultConfig: {
                    ...prev,
                    [activeContainer]: [...prev[activeContainer].filter((item) => item !== active.id)],
                    [overContainer]: [...prev[overContainer].slice(0, newIndex), this.state.teleconsultConfig[activeContainer][activeIndex], ...prev[overContainer].slice(newIndex, prev[overContainer].length)]
                }
            })
        } else {
            this.setState({
                items: {
                    ...prev,
                    [activeContainer]: [...prev[activeContainer].filter((item) => item !== active.id)],
                    [overContainer]: [...prev[overContainer].slice(0, newIndex), this.state.items[activeContainer][activeIndex], ...prev[overContainer].slice(newIndex, prev[overContainer].length)]
                }
            })
        }
    }
    
    handleDragEnd = (event) => {
        let type = 'identifier';
        const { active, over } = event;
        const { id } = active;
        const { id: overId } = over;

        if(id && ["Post Health Screening", "General Practitioner", "Dietician", "Mental Health", "ART Specialist"].includes(id)){
            type = 'teleconsult';
        }

        const activeContainer = this.findContainer(id);
        const overContainer = this.findContainer(overId);

        if (!activeContainer || !overContainer || activeContainer !== overContainer) {
            return;
        }

        let items = this.state.items;
        if(type == 'teleconsult'){
            items = this.state.teleconsultConfig
        }
        const activeIndex = this.state.teleconsultConfig[activeContainer].indexOf(active.id);
        const overIndex = this.state.teleconsultConfig[overContainer].indexOf(overId);

        if (activeIndex !== overIndex) {
            if(type == 'teleconsult'){    
                this.setState({
                    teleconsultConfig: {
                        ...items,
                        [overContainer]: arrayMove(items[overContainer], activeIndex, overIndex)
                    }
                })
            } else {
                this.setState({
                    items: {
                        ...items,
                        [overContainer]: arrayMove(items[overContainer], activeIndex, overIndex)
                    }
                })
            }
        }

        this.setState({
            activeId: null
        })
    }
    // ------- end -----

    render() {
        const { client, user } = this.props 
        const isAdminOperation = CommonUtility.haveUserType( USER_TYPE.SYS_ADMIN, user ) && CommonUtility.haveRoles( [USER_ROLES.ADMIN_OPERATION], user );
        const isAdminIT = CommonUtility.haveUserType( USER_TYPE.SYS_ADMIN, user ) && CommonUtility.haveRoles( [USER_ROLES.ADMIN_IT], user ); 
        return (
            <Formik
                initialValues={{ 
                    name: client.name || '',
                    groupCode: client.groupCode || '',
                    policyNo: client.policyNo || '',
                    inpatientPolicyNo: client.inpatientPolicyNo || '',
                    outpatientPolicyNo: client.outpatientPolicyNo || '',
                    LogF_RequireHR: client.eLogConfig.LogF_RequireHR || 0,
                    LogNF_RequireHR: client.eLogConfig.LogNF_RequireHR || 0,
                    Default_ELOG: client.eLogConfig.Default_ELOG || '',
                    Presigned_ELOG_Count: client.eLogConfig.Presigned_ELOG_Count || 0,
                    Presigned_ELOG_Amount: client.eLogConfig.Presigned_ELOG_Amount || 10000,
                    Presigned_ELOG_Limit: client.eLogConfig.Presigned_ELOG_Limit || 0,
                    Presigned_ELOG_Limit_Count: client.eLogConfig.Presigned_ELOG_Limit_Count || 0,
                    Fixed_ELOG_Limit: client.eLogConfig.Fixed_ELOG_Limit || 0,
                    Fixed_ELOG_Limit_Count: client.eLogConfig.Fixed_ELOG_Limit_Count || 0,
                    NonFixed_ELOG_Limit: client.eLogConfig.NonFixed_ELOG_Limit || 0,
                    NonFixed_ELOG_Limit_Count: client.eLogConfig.NonFixed_ELOG_Limit_Count || 0,
                    companyEmails: client.eLogConfig.companyEmails || [],
                    allowClinicLocator: client.featuresConfig.allowClinicLocator,
                    allowChat: client.featuresConfig.allowChat,
                    allowMyVisit: client.featuresConfig.allowMyVisit,
                    itemizedMonth: client.featuresConfig.itemizedMonth,
                    itemizedMessage: client.featuresConfig.itemizedMessage,
                    allowLOG: client.featuresConfig.allowLOG,
                    allowMarketplace: client.featuresConfig.allowMarketplace,
                    allowStretchMyDollar: client.featuresConfig.allowStretchMyDollar,
                    allowNotification: client.featuresConfig.allowNotification,
                    allowEcard: client.featuresConfig.allowEcard,
                    allowEclaimSubmit: client.featuresConfig.allowEclaimSubmit,
                    allowViewBenefitBalance: client.featuresConfig.allowViewBenefitBalance,
                    allowMyPlan: client.featuresConfig.allowMyPlan,
                    allowHealthArticles: client.featuresConfig.allowHealthArticles,
                    allowOutpatient: client.featuresConfig.allowOutpatient,
                    allowInpatient: client.featuresConfig.allowInpatient,
                    allowEmployeeChangeEmail: client.featuresConfig.allowEmployeeChangeEmail,
                    allowDependantChangeEmail: client.featuresConfig.allowDependantChangeEmail,
                    allowTeleconsult: client.featuresConfig.allowTeleconsult,
                    allowTeleconsultDependant: client.featuresConfig.allowTeleconsultDependant,
                    teleconsultAppLink: client.featuresConfig.teleconsultAppLink,
                    cacheECard: client.featuresConfig.cacheECard,
                    chequeOnly: client.featuresConfig.chequeOnly,
                    giroOnly: client.featuresConfig.giroOnly,
                    disableMessage: client.featuresConfig.disableMessage,
                    requireRegistrationEmail: this.props.client.featuresConfig.requireRegistrationEmail,
                    allowEAP: client.featuresConfig.allowEAP,
                    userGuideUrl: client.featuresConfig.userGuideUrl,
                    restrictOTP: client.featuresConfig.restrictOTP,
                    requireOTPClinicLocator: client.featuresConfig.requireOTPClinicLocator,
                    requireOTPLOG: client.featuresConfig.requireOTPLOG,
                    requireOTPClaims: client.featuresConfig.requireOTPClaims,
                    requireOTPRewards: client.featuresConfig.requireOTPRewards,
                    requireOTPStore: client.featuresConfig.requireOTPStore,
                    requireOTPEcard: client.featuresConfig.requireOTPEcard,
                    requireOTPTeleconsult: client.featuresConfig.requireOTPTeleconsult,
                    requireOTPProfile: client.featuresConfig.requireOTPProfile,
                    requireOTPUserGuide: client.featuresConfig.requireOTPUserGuide,
                    requireOTPArticle: client.featuresConfig.requireOTPArticle,
                    requireOTPNotification: client.featuresConfig.requireOTPNotification,
                    requireOTPAskJoey: client.featuresConfig.requireOTPAskJoey,
                    allowEditRegistrationEmail: client.featuresConfig.allowEditRegistrationEmail,

                    articleCompanyId:client.featuresConfig.articleCompanyId || '',   

                    submittedOutpatientClaimEmailTemplateId:client.featuresConfig.submittedOutpatientClaimEmailTemplateId || '',
                    submittedOutpatientClaimPushTemplateId:client.featuresConfig.submittedOutpatientClaimPushTemplateId || '',

                    submittedInpatientClaimEmailTemplateId:client.featuresConfig.submittedInpatientClaimEmailTemplateId || '',
                    submittedInpatientClaimPushTemplateId:client.featuresConfig.submittedInpatientClaimPushTemplateId || '',

                    firstNotificationClaimEmailTemplateId:client.featuresConfig.firstNotificationClaimEmailTemplateId || '',
                    firstNotificationClaimPushTemplateId:client.featuresConfig.firstNotificationClaimPushTemplateId || '',

                    firstReminderClaimEmailTemplateId:client.featuresConfig.firstReminderClaimEmailTemplateId || '',
                    firstReminderClaimPushTemplateId:client.featuresConfig.firstReminderClaimPushTemplateId || '',

                    secondReminderClaimEmailTemplateId:client.featuresConfig.secondReminderClaimEmailTemplateId || '',
                    secondReminderClaimPushTemplateId:client.featuresConfig.secondReminderClaimPushTemplateId || '',

                    closureClaimEmailTemplateId:client.featuresConfig.closureClaimEmailTemplateId || '',  
                    closureClaimPushTemplateId:client.featuresConfig.closureClaimPushTemplateId || '',

                    approvedClaimEmailTemplateId:client.featuresConfig.approvedClaimEmailTemplateId || '',
                    approvedClaimPushTemplateId:client.featuresConfig.approvedClaimPushTemplateId || '',

                    rejectedClaimEmailTemplateId:client.featuresConfig.rejectedClaimEmailTemplateId || '',
                    rejectedClaimPushTemplateId:client.featuresConfig.rejectedClaimPushTemplateId || '',

                    marketplacePurchasedEmailTemplateId:client.featuresConfig.marketplacePurchasedEmailTemplateId || '',
                    marketplacePurchasedPushTemplateId:client.featuresConfig.marketplacePurchasedPushTemplateId || '',

                    marketplaceRedeemedEmailTemplateId:client.featuresConfig.marketplaceRedeemedEmailTemplateId || '',
                    marketplaceRedeemedPushTemplateId:client.featuresConfig.marketplaceRedeemedPushTemplateId || '',

                    eLogNotificationTemplateId:client.featuresConfig.eLogNotificationTemplateId || '',
                    simpleEmailNotificationTemplateId:client.featuresConfig.simpleEmailNotificationTemplateId || '',

                    birthDayPushTemplateId:client.featuresConfig.birthDayPushTemplateId || '',
                    accessTokenPushTemplateId:client.featuresConfig.accessTokenPushTemplateId || '',

                    welcomeEmailTemplateId:client.featuresConfig.welcomeEmailTemplateId || '', 
                    emailOTPTemplateId:client.featuresConfig.emailOTPTemplateId || '', 
                    resetPasswordTemplateId:client.featuresConfig.resetPasswordTemplateId || '', 
                    succeedResetPasswordTemplateId:client.featuresConfig.succeedResetPasswordTemplateId || '',
                    smsOTPTemplateId:client.featuresConfig.smsOTPTemplateId || '', 

                    templateAlias: client.onboardingEmailConfig.templateAlias,
                    testEmail: client.onboardingEmailConfig.testEmail,
                    status: client.status || '',
                    companyMS_company_id: client.companyMS_company_id || '',
                    userDataFromCustomerMS: client.featuresConfig.userDataFromCustomerMS,
                    payNowOnly: client.featuresConfig.payNowOnly,
                    payrollOnly: client.featuresConfig.payrollOnly,
                    allowEclaimPaymentByInsurer: client.featuresConfig.allowEclaimPaymentByInsurer,
                    maximumFileUpload: client.featuresConfig.maximumFileUpload ? client.featuresConfig.maximumFileUpload : 5,
                    OTPtype: client.featuresConfig.OTPtype ? client.featuresConfig.OTPtype : 'EMAIL', 
                }}
                validateOnChange={false}
                validateOnBlur={false}
                // validationSchema={OutpatientValidationSchema}
                onSubmit={(values, actions) => {  
                    if (!values.isSecondButton){
                        this.setState({error: false, errorMessage: null, success: false}); 
                        values.teleconsult_features_config = this.state.teleconsultConfig.root;

                        this.props.submitSystemAdminUpdateClient(
                            {accessToken: this.props.user.accessToken, data:values, clientId: this.props.clientId},
                            (result, error) => {
                                if (result) {
                                    actions.setSubmitting(false);
                                    this.setState({error: false, errorMessage: null, success: true});
                                }
                                if (error) {
                                    actions.setSubmitting(false);
                                    this.setState({error: true, errorMessage: error.errorMessage});
                                }
                            }
                        )

                    }else {     
                        this.setState({openModalSelectCompany:true}) 
                    }
                    
                }} 
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue
                }) => (
                    
                    <Form style={{padding: 20}}>
                        {this.props.user && <ListMSBillingCompanySelection
                            open={ this.state.openModalSelectCompany }
                            clients={this.state.clients}
                            // onSelectCompany={this.onSelectCompany.bind(this)}
                            onSelectCompany={ (client) => {
                                            this.onSelectCompany(client);
                                        }}
                            onClose={()=>{ this.showCompanyDialog(false) }}
                            currentPage={this.state.currentPage }
                            perPage={this.state.perPage }
                            totalPage={this.state.totalPage }
                            totalData={this.state.totalData }
                            filter={this.state.filter }
                            query={ this.state.query }
                            // getClients={ this.getClients.bind(this) }
                            submitFilter={ this.submitFilter.bind(this) }
                            clearFilter={ this.clearFilter.bind(this) }
                            checkClearFilter={ this.checkClearFilter.bind(this) }

                            goToPreviousPage={ this.goToPreviousPage.bind(this) }
                            goToNextPage={ this.goToNextPage.bind(this) }
                            setPage={ this.setPage.bind(this) }
                            setPerPage={ this.setPerPage.bind(this) }

                            onFilterDropdownChange={this.onFilterDropdownChange.bind(this)}
                            filterOptions={filterOptions}
                            isLoading={this.state.loading}
                            isSearch={this.state.isSearch}
                        />}
                        <Grid container columns={2}>
                            {this.state.isCloned?<Grid.Column width={16}>
                                {this.renderSubmissionResult()}
                            </Grid.Column>:null}
                            <Grid.Column width={16}>
                                <Divider horizontal>
                                    Company Basic Information
                                </Divider>
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="name" 
                                    label="Company Name" 
                                    component={FormsInputsText} 
                                    secondaryLabel=""
                                    disabled={true}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="groupCode" 
                                    label="Group Code" 
                                    component={FormsInputsText} 
                                    secondaryLabel=""
                                    disabled={true}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="policyNo" 
                                    label="Policy Number" 
                                    component={FormsInputsText} 
                                    secondaryLabel=""
                                    disabled={true}
                                />
                            </Grid.Column>
                            {/* <Grid.Column>
                                <Field 
                                    name="inpatientPolicyNo" 
                                    label="Inpatient Policy Number" 
                                    component={FormsInputsText} 
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="outpatientPolicyNo" 
                                    label="Outpatient Policy Number" 
                                    component={FormsInputsText} 
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column> */}
                            <Grid.Column width={16}>
                                <Divider horizontal>
                                    LOG Information
                                </Divider>
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="LogF_RequireHR" 
                                    label="Log Fixed Require HR Approval" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="LogNF_RequireHR" 
                                    label="Log Non-Fixed Require HR Approval" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <Field 
                                    name="Default_ELOG" 
                                    label="Default ELOG Type" 
                                    component={FormsInputDropdown} 
                                    options={defaultElogType}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="Presigned_ELOG_Count" 
                                    label="Presigned ELOG Count" 
                                    component={FormsInputsNumber} 
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="Presigned_ELOG_Amount" 
                                    label="Presigned ELOG Amount" 
                                    component={FormsInputsNumber} 
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="Presigned_ELOG_Limit" 
                                    label="Presigned ELOG Limit" 
                                    component={FormsInputsText} 
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="Presigned_ELOG_Limit_Count" 
                                    label="Presigned ELOG Limit Count" 
                                    component={FormsInputsText} 
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="Fixed_ELOG_Limit" 
                                    label="Fixed ELOG Limit" 
                                    component={FormsInputsText} 
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="Fixed_ELOG_Limit_Count" 
                                    label="Fixed ELOG Limit Count" 
                                    component={FormsInputsText} 
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="NonFixed_ELOG_Limit" 
                                    label="Non Fixed ELOG Limit" 
                                    component={FormsInputsText} 
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="NonFixed_ELOG_Limit_Count" 
                                    label="Non Fixed ELOG Limit Count" 
                                    component={FormsInputsText} 
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <FieldArray
                                    name="companyEmails" 
                                    render={
                                        (arrayHelpers) => (
                                            <div>
                                                {
                                                    (values.companyEmails && values.companyEmails.length > 0) ? 
                                                    (
                                                        values.companyEmails.map((cEmail, index) => {
                                                            return (
                                                                <div key={index}>
                                                                <Field 
                                                                    name={`companyEmails.${index}`} 
                                                                    component={FormsInputsText} 
                                                                    label={`LOG Company Email To Send To : ${index + 1}`}
                                                                    secondaryLabel=""
                                                                    disabled={!isAdminOperation}
                                                                />
                                                                {
                                                                    isAdminOperation && 
                                                                    <React.Fragment>
                                                                        <Button
                                                                            type="button"
                                                                            fluid
                                                                            onClick={() => arrayHelpers.remove(index)} // remove a friend from the list
                                                                        >
                                                                            -
                                                                        </Button>
                                                                        <Button
                                                                            type="button"
                                                                            fluid
                                                                            onClick={() => arrayHelpers.insert(index, '')} // insert an empty string at a position
                                                                        >
                                                                            +
                                                                        </Button>
                                                                    </React.Fragment>
                                                                }
                                                            </div>
                                                            );
                                                        })
                                                    )
                                                    :
                                                    (
                                                        isAdminOperation &&
                                                        <Button type="button" fluid onClick={() => arrayHelpers.push('')}>
                                                            {/* show this when user has removed all friends from the list */}
                                                            Add a company contact email
                                                        </Button>
                                                    )
                                                }
                                            </div>
                                        )
                                    }
                                />
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <Divider horizontal>
                                    Features Configuration
                                </Divider>
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="allowClinicLocator" 
                                    label="Allow View Clinic Locator" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="allowChat" 
                                    label="Allow View Chat" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="allowLOG" 
                                    label="Allow View Letter of Guarantee" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="allowMyVisit" 
                                    label="Allow View My Visit" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field
                                    name="itemizedMonth"
                                    label="Display incurred amount break down"
                                    tooltip="Display incurred amount break down in visit detail after x month"
                                    component={FormsInputsNumber}
                                    min="0"
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field
                                    name="itemizedMessage"
                                    label="Display incurred amount message"
                                    tooltip="Display incurred amount message in visit detail before x month"
                                    component={FormsInputsText}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="allowMarketplace" 
                                    label="Allow View Marketplace" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="allowEAP" 
                                    label="Allow View EAP" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="allowStretchMyDollar" 
                                    label="Allow View Stretch My Dollar" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="allowNotification" 
                                    label="Allow View Notification" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="allowEcard" 
                                    label="Allow Ecard Feature" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="allowEclaimSubmit" 
                                    label="Allow Eclaim Submission Feature" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            {/* <Grid.Column>
                                <Field 
                                    name="allowViewBenefitBalance" 
                                    label="Allow View Benefit Balance Feature" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column> */}
                            <Grid.Column>
                                <Field 
                                    name="allowMyPlan" 
                                    label="Allow View My Plan" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="allowHealthArticles" 
                                    label="Allow View Health Articles" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                             <Grid.Column>
                                <Field 
                                    name="allowOutpatient" 
                                    label="Allow Submit OutPatient eclaim" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="allowInpatient" 
                                    label="Allow Submit Inpatient eclaim" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="allowEmployeeChangeEmail" 
                                    label="Allow Employee Change Email" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="allowDependantChangeEmail" 
                                    label="Allow Dependant Change Email" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="allowTeleconsult" 
                                    label="Allow Teleconsult" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="allowTeleconsultDependant" 
                                    label="Allow Teleconsult Dependant" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="teleconsultAppLink" 
                                    label="Teleconsult App Link" 
                                    component={FormsInputsText} 
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="requireRegistrationEmail" 
                                    label="Require Registration Email" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            {values.requireRegistrationEmail &&
                            <Grid.Column>
                                <Field 
                                    name="allowEditRegistrationEmail" 
                                    label="Allow Edit Registration Email" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>}
                            <Grid.Column>
                                <Field 
                                    name="cacheECard" 
                                    label="Allow retrieve cache Ecard" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="chequeOnly" 
                                    label="Allow eclaim pay by Cheque" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="giroOnly" 
                                    label="Allow eclaim pay by giro" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="payrollOnly"
                                    label="Allow eclaim pay by payroll" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="allowEclaimPaymentByInsurer"
                                    label="Allow Eclaim pay by Insurer" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="payNowOnly"
                                    label="Allow eclaim pay by PayNow via NRIC" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="disableMessage" 
                                    label="Feature disabled error message" 
                                    component={FormsInputsText} 
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="userGuideUrl" 
                                    label="Url to show user guide" 
                                    component={FormsInputsText} 
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="restrictOTP" 
                                    label="Restrict OTP when Login" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>

                            <Grid.Column>
                                <Field 
                                    name="userDataFromCustomerMS"
                                    label="Retrieve member data from customer MS (Only for HR)" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>

                            <Grid.Column>
                                <Field 
                                    name="maximumFileUpload" 
                                    label="Maximum file upload on web" 
                                    component={FormsInputsNumber}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            
                            <Grid.Column width={16}>
                                <Divider horizontal>
                                    OTP require Configuration
                                </Divider>
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="OTPtype" 
                                    label="OTP Type" 
                                    component={FormsInputDropdown} 
                                    options={otpOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="requireOTPClinicLocator" 
                                    label="Required OTP (Clinic Locator)" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="requireOTPLOG" 
                                    label="Required OTP (Letter of Guarantee)" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="requireOTPClaims" 
                                    label="Required OTP (Eclaim)" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="requireOTPRewards" 
                                    label="Required OTP (Rewards)" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="requireOTPStore" 
                                    label="Required OTP (Store)" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="requireOTPEcard" 
                                    label="Required OTP (ECard)" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="requireOTPProfile" 
                                    label="Required OTP (Profile)" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="requireOTPUserGuide" 
                                    label="Required OTP (User Guide)" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="requireOTPArticle" 
                                    label="Required OTP (Article)" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="requireOTPTeleconsult" 
                                    label="Required OTP (Teleconsult)" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="requireOTPNotification" 
                                    label="Required OTP (Notification)" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field 
                                    name="requireOTPAskJoey" 
                                    label="Required OTP (Ask Joey)" 
                                    component={FormsInputDropdown} 
                                    options={yesNoOneTwoBooleanOptions}
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            {isAdminIT &&
                                <Grid.Column width={16}>
                                    <Divider horizontal>
                                        Microservices Configuration
                                    </Divider>
                                </Grid.Column>}
                                 {isAdminIT && 
                                <Grid.Column>
                                    <Field 
                                        name="companyMS_company_id" 
                                        label="Company Microservice Company ID" 
                                        component={FormsInputsText}  
                                        secondaryLabel=""
                                        disabled={true}
                                    />
                                </Grid.Column>}
                                {isAdminIT && 
                                <Grid.Column>
                                    <Field 
                                        name="articleCompanyId" 
                                        label="Article Company ID" 
                                        component={FormsInputsText}  
                                        secondaryLabel=""
                                        disabled={!isAdminOperation}
                                    />
                                </Grid.Column>}
                                {isAdminIT && 
                                <Grid.Column>
                                    <Field 
                                        name="submittedOutpatientClaimEmailTemplateId" 
                                        label="Submitted Outpatient Claim Email Template ID" 
                                        component={FormsInputsText}  
                                        secondaryLabel=""
                                        disabled={!isAdminOperation}
                                    />
                                </Grid.Column>} 
                                {isAdminIT && 
                                <Grid.Column>
                                    <Field 
                                        name="submittedInpatientClaimEmailTemplateId" 
                                        label="Submitted Inpatient Claim Email Template ID" 
                                        component={FormsInputsText}  
                                        secondaryLabel=""
                                        disabled={!isAdminOperation}
                                    />
                                </Grid.Column>} 
                                {isAdminIT && 
                                <Grid.Column>
                                    <Field 
                                        name="firstNotificationClaimEmailTemplateId" 
                                        label="First Notification Claim Email Template ID" 
                                        component={FormsInputsText}  
                                        secondaryLabel=""
                                        disabled={!isAdminOperation}
                                    />
                                </Grid.Column>}
                                {isAdminIT && 
                                <Grid.Column>
                                    <Field 
                                        name="firstReminderClaimEmailTemplateId" 
                                        label="First Reminder Claim Email Template ID" 
                                        component={FormsInputsText}  
                                        secondaryLabel=""
                                        disabled={!isAdminOperation}
                                    />
                                </Grid.Column>}
                                {isAdminIT && 
                                <Grid.Column>
                                    <Field 
                                        name="secondReminderClaimEmailTemplateId" 
                                        label="Second Reminder Claim Email Template ID" 
                                        component={FormsInputsText}  
                                        secondaryLabel=""
                                        disabled={!isAdminOperation}
                                    />
                                </Grid.Column>}
                                {isAdminIT && 
                                <Grid.Column>
                                    <Field 
                                        name="closureClaimEmailTemplateId" 
                                        label="Closure Claim Email Template ID" 
                                        component={FormsInputsText}  
                                        secondaryLabel=""
                                        disabled={!isAdminOperation}
                                    />
                                </Grid.Column>}
                                {isAdminIT && 
                                <Grid.Column>
                                    <Field 
                                        name="approvedClaimEmailTemplateId" 
                                        label="Approved Claim Email Template ID" 
                                        component={FormsInputsText}  
                                        secondaryLabel=""
                                        disabled={!isAdminOperation}
                                    />
                                </Grid.Column>}
                                {isAdminIT && 
                                <Grid.Column>
                                    <Field 
                                        name="rejectedClaimEmailTemplateId" 
                                        label="Rejected Claim Email Template ID" 
                                        component={FormsInputsText}  
                                        secondaryLabel=""
                                        disabled={!isAdminOperation}
                                    />
                                </Grid.Column>} 
                                {isAdminIT && 
                                    <Grid.Column>
                                        <Field 
                                            name="marketplacePurchasedEmailTemplateId" 
                                            label="Purchased Marketplace Email Template ID" 
                                            component={FormsInputsText}  
                                            secondaryLabel=""
                                            disabled={!isAdminOperation}
                                        />
                                    </Grid.Column>} 
                                {isAdminIT && 
                                    <Grid.Column>
                                        <Field 
                                            name="marketplaceRedeemedEmailTemplateId" 
                                            label="Redeemed Marketplace Email Template ID" 
                                            component={FormsInputsText}  
                                            secondaryLabel=""
                                            disabled={!isAdminOperation}
                                        />
                                    </Grid.Column>} 

                                {isAdminIT && 
                                    <Grid.Column>
                                        <Field 
                                            name="eLogNotificationTemplateId" 
                                            label="eLOG Email Template ID" 
                                            component={FormsInputsText}  
                                            secondaryLabel=""
                                            disabled={!isAdminOperation}
                                        />
                                    </Grid.Column>} 
                                {isAdminIT && 
                                    <Grid.Column>
                                        <Field 
                                            name="simpleEmailNotificationTemplateId" 
                                            label="Simple Email Template ID" 
                                            component={FormsInputsText}  
                                            secondaryLabel=""
                                            disabled={!isAdminOperation}
                                        />
                                    </Grid.Column>} 

                                    {isAdminIT && 
                                    <Grid.Column>
                                        <Field 
                                            name="submittedOutpatientClaimPushTemplateId" 
                                            label="Submitted Outpatient Claim Push Notification Template ID" 
                                            component={FormsInputsText}  
                                            secondaryLabel=""
                                            disabled={!isAdminOperation}
                                        />
                                    </Grid.Column>}
                                    {isAdminIT && 
                                    <Grid.Column>
                                        <Field 
                                            name="submittedInpatientClaimPushTemplateId" 
                                            label="Submitted Inpatient Claim Push Notification Template ID" 
                                            component={FormsInputsText}  
                                            secondaryLabel=""
                                            disabled={!isAdminOperation}
                                        />
                                    </Grid.Column>}  
                                    {isAdminIT && 
                                    <Grid.Column>
                                        <Field 
                                            name="firstNotificationClaimPushTemplateId" 
                                            label="First Notification Claim Push Notification Template ID" 
                                            component={FormsInputsText}  
                                            secondaryLabel=""
                                            disabled={!isAdminOperation}
                                        />
                                    </Grid.Column>}  
                                    {isAdminIT && 
                                    <Grid.Column>
                                        <Field 
                                            name="firstReminderClaimPushTemplateId" 
                                            label="First Reminder Claim Push Notification Template ID" 
                                            component={FormsInputsText}  
                                            secondaryLabel=""
                                            disabled={!isAdminOperation}
                                        />
                                    </Grid.Column>} 
                                    {isAdminIT && 
                                    <Grid.Column>
                                        <Field 
                                            name="secondReminderClaimPushTemplateId" 
                                            label="Second Reminder Claim Push Notification Template ID" 
                                            component={FormsInputsText}  
                                            secondaryLabel=""
                                            disabled={!isAdminOperation}
                                        />
                                    </Grid.Column>} 
                                    {isAdminIT && 
                                    <Grid.Column>
                                        <Field 
                                            name="closureClaimPushTemplateId" 
                                            label="Closure Claim Push Notification Template ID" 
                                            component={FormsInputsText}  
                                            secondaryLabel=""
                                            disabled={!isAdminOperation}
                                        />
                                    </Grid.Column>} 
                                    {isAdminIT && 
                                    <Grid.Column>
                                        <Field 
                                            name="approvedClaimPushTemplateId" 
                                            label="Approved Claim Push Notification Template ID" 
                                            component={FormsInputsText}  
                                            secondaryLabel=""
                                            disabled={!isAdminOperation}
                                        />
                                    </Grid.Column>} 
                                    {isAdminIT && 
                                    <Grid.Column>
                                        <Field 
                                            name="rejectedClaimPushTemplateId" 
                                            label="Rejected Claim Push Notification Template ID" 
                                            component={FormsInputsText}  
                                            secondaryLabel=""
                                            disabled={!isAdminOperation}
                                        />
                                    </Grid.Column>}   
                                    {isAdminIT && 
                                    <Grid.Column>
                                        <Field 
                                            name="birthDayPushTemplateId" 
                                            label="Birth Day Push Notification Template ID" 
                                            component={FormsInputsText}  
                                            secondaryLabel=""
                                            disabled={!isAdminOperation}
                                        />
                                    </Grid.Column>} 
                                    {isAdminIT && 
                                    <Grid.Column>
                                        <Field 
                                            name="accessTokenPushTemplateId" 
                                            label="Access Token Push Notification Template ID" 
                                            component={FormsInputsText}  
                                            secondaryLabel=""
                                            disabled={!isAdminOperation}
                                        />
                                    </Grid.Column>}   
                                    {isAdminIT && 
                                        <Grid.Column>
                                            <Field 
                                                name="marketplacePurchasedPushTemplateId" 
                                                label="Purchased Marketplace Push Template ID" 
                                                component={FormsInputsText}  
                                                secondaryLabel=""
                                                disabled={!isAdminOperation}
                                            />
                                        </Grid.Column>} 
                                    {isAdminIT && 
                                        <Grid.Column>
                                            <Field 
                                                name="marketplaceRedeemedPushTemplateId" 
                                                label="Redeemed Marketplace Push Template ID" 
                                                component={FormsInputsText}  
                                                secondaryLabel=""
                                                disabled={!isAdminOperation}
                                            />
                                        </Grid.Column>} 
                                    {isAdminIT && 
                                    <Grid.Column>
                                        <Field 
                                            name="welcomeEmailTemplateId" 
                                            label="Welcome Email" 
                                            component={FormsInputsText}  
                                            secondaryLabel=""
                                            disabled={!isAdminOperation}
                                        />
                                    </Grid.Column>}
                                    {isAdminIT && 
                                    <Grid.Column>
                                        <Field 
                                            name="emailOTPTemplateId" 
                                            label="Email OTP" 
                                            component={FormsInputsText}  
                                            secondaryLabel=""
                                            disabled={!isAdminOperation}
                                        />
                                    </Grid.Column>}
                                    {isAdminIT && 
                                    <Grid.Column>
                                        <Field 
                                            name="resetPasswordTemplateId" 
                                            label="Reset Password" 
                                            component={FormsInputsText}  
                                            secondaryLabel=""
                                            disabled={!isAdminOperation}
                                        />
                                    </Grid.Column>}
                                    {isAdminIT && 
                                    <Grid.Column>
                                        <Field 
                                            name="succeedResetPasswordTemplateId" 
                                            label="Succeed Reset Password" 
                                            component={FormsInputsText}  
                                            secondaryLabel=""
                                            disabled={!isAdminOperation}
                                        />
                                    </Grid.Column>}
                                    {isAdminIT && 
                                    <Grid.Column>
                                        <Field 
                                            name="smsOTPTemplateId" 
                                            label="SMS OTP" 
                                            component={FormsInputsText}  
                                            secondaryLabel=""
                                            disabled={!isAdminOperation}
                                        />
                                    </Grid.Column>}
                            <Grid.Column width={16}>
                                <Divider horizontal>
                                    Onboarding Email Configuration
                                </Divider>
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <Message 
                                    warning
                                    header='Please read this before you configure.'
                                    list={[
                                        'If Template Alias is specified, onboarding email will be triggered hourly.',
                                        'For testing purpose, please make sure Test Email is specified in order to send to this email only.',
                                        'If Test Email is not specified, onboarding email will be sent to all employees that have not received the email under this company.'
                                    ]}
                                />
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <Field 
                                    name="templateAlias" 
                                    label="Template Alias" 
                                    component={FormsInputsText} 
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <Field 
                                    name="testEmail" 
                                    label="Test Email (must be a user in this company where if specify, onboarding email will only be sent to this email)" 
                                    component={FormsInputsText} 
                                    secondaryLabel=""
                                    disabled={!isAdminOperation}
                                />
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <Divider horizontal>
                                    Teleconsult Config
                                </Divider>
                            </Grid.Column>
                            <DndContext
                                collisionDetection={closestCorners.bind(this)}
                                onDragStart={this.handleDragStart.bind(this)}
                                onDragOver={this.handleDragOver.bind(this)}
                                onDragEnd={this.handleDragEnd.bind(this) }
                            >
                                <Container id="root" items={this.state.teleconsultConfig.root} />
                                <Container id="container1" items={this.state.teleconsultConfig.container1} />
                                <DragOverlay>{this.state.activeId ? <Item id={this.state.activeId} /> : null}</DragOverlay>
                            </DndContext>
                           {isAdminOperation && 
                            <Grid.Row>
                                <Grid.Column>
                                <Button 
                                        loading={isSubmitting && !values.isSecondButton}
                                        type="submit" 
                                        primary 
                                        disabled={isSubmitting && !values.isSecondButton}
                                        fluid
                                        size="big"
                                        onClick={(e)=>{
                                            setFieldValue('isSecondButton',false) 
                                          }}
                                    >
                                        Update Client
                                    </Button>
                                </Grid.Column>
                                <Grid.Column>
                                <Button 
                                    loading={isSubmitting && values.isSecondButton}
                                    type="submit" 
                                    active 
                                    disabled={isSubmitting && values.isSecondButton}
                                    fluid
                                    size="big" 
                                    onClick={()=>{
                                        this.showCompanyDialog(true)
                                        setFieldValue('isSecondButton',true) 
                                    }}
                                >
                                    Clone
                                </Button>
                                </Grid.Column>
                            </Grid.Row>} 
                            {!this.state.isCloned && this.state.success ?<Grid.Column width={16}>
                                {this.renderSubmissionResult()}
                            </Grid.Column>:null}
                        </Grid>
                    </Form>
                )}
            />
        );
    }
}

export default withRouter(connect(null, {submitSystemAdminCreateClient})(SysadminFormsClientUpdate))